import { QuoteFormSection as QuoteFormData } from "#app/types/schema.ts"
import { SectionDefaultProps } from "#app/types/type.ts"
import { stegaClean } from "@sanity/client/stega"
import { Heading, Text } from "./text"
import { QuoteForm } from "#app/routes/resources+/get-a-quote.tsx"
import { cn } from "#app/utils/misc.tsx"


type QuoteFormSectionProps = SectionDefaultProps & {
  data: QuoteFormData
}

const sectionColorScheme = {
    default: "bg-background text-foreground",
    primary: "bg-primary text-primary-foreground py-12 sm:py-20",
    secondary: "bg-secondary text-secondary-foreground py-12 sm:py-20",
    muted: "bg-muted text-foreground py-12 sm:py-20",
    accent: "bg-accent text-accent-foreground py-12 sm:py-20",
}

export default function QuoteFormSection({ data }: QuoteFormSectionProps) {
    const quoteFormData = stegaClean(data);
    const { heading, headingLevel, description, backgroundStyle } = quoteFormData;
    const sectionClasses = cn(
        sectionColorScheme[backgroundStyle]
    )
    return (
        <div id="quote-form-section" className={sectionClasses}>
            <div className="container px-6 lg:px-8">
                <div className="max-w-2xl mx-auto text-center flex flex-col justify-center">
                    {heading && (
                        <Heading as={headingLevel} className="text-5xl font-bold text-balance sm:text-6xl">
                            {heading}
                        </Heading>
                    )}
                    {description && (
                        <Text className="text-xl mt-7">
                            {description}
                        </Text>
                    )}
                </div>
                <div className="mx-auto mt-16 max-w-xl sm:mt-20">
                    <QuoteForm />
                </div>
            </div>
        </div>
    )
}